<template>
  <div class="w-full flex flex-col md:max-w-[600px] px-2">
    <settings-toggle
      class="mb-1"
      :status="enableDirectProductOrders"
      title="הזמנת מוצרים ישירות מהאתר"
      description="לקוחות יוכלו להזמין מוצרים לאיסוף עצמי, ללא קביעת תור (בתשלום אונליין בלבד)"
      @value-changed="(val) => {enableDirectProductOrders = val; updateSettings();}"/>

    <div class="flex flex-col gap-2 mt-6">
      <span class="font-medium">מדיניות הזמנת מוצרים</span>
      <span class="text-sm text-surface-500">טקסט חופשי שיוצג ללקוחות בעמוד ההזמנה (לדוגמה: שעות איסוף, מדיניות ביטולים)</span>
      <Textarea
        v-model="productPickupPolicy"
        rows="3"
        autoResize
        maxlength="1000"
        class="w-full text-sm"
        placeholder="לדוגמה: איסוף בשעות הפעילות בלבד, יש להציג את מספר ההזמנה" />
      <Button
        label="שמירת מדיניות"
        size="small"
        class="self-start"
        :disabled="productPickupPolicy === savedPickupPolicy"
        @click="updateSettings" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref} from "vue";
import Textarea from 'primevue/textarea';
import {ShopApi} from "@app/api/admin/shop-api";
import {useToast} from "vue-toastification";
import {useAdminStore} from "@app/stores";
import { trackEvent } from '@app/composables/posthog';

const toast = useToast();
const adminStore = useAdminStore();

const enableDirectProductOrders = ref(true);
const productPickupPolicy = ref('');
const savedPickupPolicy = ref('');

const updateSettings = async () => {
  trackEvent('shop_settings_saved');
  try {
    await ShopApi.editSettings({
      enableDirectProductOrders: enableDirectProductOrders.value,
      productPickupPolicy: productPickupPolicy.value,
    });
    savedPickupPolicy.value = productPickupPolicy.value;
    toast.success('ההגדרות עודכנו בהצלחה');
    await adminStore.fetchBusinessData();
  } catch (e) {
    console.error(e);
    toast.error('לא הצלחנו לעדכן את ההגדרות, אנא נסו שוב');
  }
}

const configurations = adminStore.businessSiteData?.configurations;
if (configurations?.enableDirectProductOrders !== undefined) {
  enableDirectProductOrders.value = configurations.enableDirectProductOrders;
}
if (configurations?.productPickupPolicy) {
  productPickupPolicy.value = configurations.productPickupPolicy;
  savedPickupPolicy.value = configurations.productPickupPolicy;
}
</script>

<style scoped lang="scss">

</style>
